import imagen2 from '../assets/testimagen2.jpg';
import imagen3 from '../assets/testimagen3.jpg';
import logoAmericanExpress from '../assets/americanExpress.png';
import logoMastercard from '../assets/mastercard.png';
import logoVisa from '../assets/visa.png';
import bonificaciones_img from '../assets/bonificaciones-vigentes.png';
import { useState, useEffect } from 'react';
import {
  Modal,
  ScrollArea,
  Text,
  Stack,
  Title,
  List,
  Image,
  Divider,
  Box,
  Button,
  Group,
  Space,
  Alert,
  Anchor,
  Center,
  TypographyStylesProvider
} from '@mantine/core';
import { IconChevronRight, IconRosetteDiscount, IconExclamationCircle, IconPoint } from '@tabler/icons-react';
import { useMediaQuery } from '@mantine/hooks';

const BonusesInfoModal = ({ t, isOpened, onClose }) => {
  const isMobile = useMediaQuery('(max-width: 50em)');
  const isMicrocredencial = t === 'm';

  // HTML de bonificaciones vigentes que mantiene Contenidos en Umbraco
  // (Home → tab "Bonificaciones Generales"). null = todavía no se pidió;
  // '' = falló o vino vacío (se muestra el contenido de respaldo hardcodeado).
  const [bonifHtml, setBonifHtml] = useState(null);

  // Idem para microcredenciales (t=m): richtext "Bonificaciones" de la carpeta
  // Microcredenciales en el Umbraco de micro, servido por /checkout/bonificaciones/micro.
  const [bonifMicroHtml, setBonifMicroHtml] = useState(null);

  useEffect(() => {
    if (!isOpened || isMicrocredencial || bonifHtml !== null) return;
    fetch(`${process.env.REACT_APP_API_BASE_URL}/checkout/bonificaciones`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => setBonifHtml(data && data.html ? data.html : ''))
      .catch(() => setBonifHtml(''));
  }, [isOpened, isMicrocredencial, bonifHtml]);

  useEffect(() => {
    if (!isOpened || !isMicrocredencial || bonifMicroHtml !== null) return;
    fetch(`${process.env.REACT_APP_API_BASE_URL}/checkout/bonificaciones/micro`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => setBonifMicroHtml(data && data.html ? data.html : ''))
      .catch(() => setBonifMicroHtml(''));
  }, [isOpened, isMicrocredencial, bonifMicroHtml]);

  return (
    <Modal
      opened={isOpened}
      onClose={onClose}
      size="70%" 
      fullScreen={isMobile}
      padding="xs"
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 3,
      }}
      scrollAreaComponent={ScrollArea.Autosize}
    >
      <div style={{padding:'1rem 2rem'}}>
        <Stack spacing="md">
          {isMicrocredencial ? (
            bonifMicroHtml ? (
              /* Contenido vivo desde el Umbraco de micro (richtext "Bonificaciones" de la
                 carpeta Microcredenciales). */
              <TypographyStylesProvider>
                <div dangerouslySetInnerHTML={{ __html: bonifMicroHtml }} />
              </TypographyStylesProvider>
            ) : bonifMicroHtml === null ? (
              /* Cargando: no mostrar el respaldo que después se pisa. */
              null
            ) : (
            <>
              <Image
                src={bonificaciones_img}
                height={120}
                fit="cover"
              />
              <Title fw={500} mb="md">
                Bonificaciones disponibles para microcredenciales{" "}
                <span style={{ color: "#f20a61" }}>UAI Advance</span>
              </Title>

              <Box>
                <Title order={3} fw={500} mb="md">Para personas externas a la comunidad UAI:</Title>
                <List 
                  withPadding 
                  spacing="xs" 
                  size='md' 
                  icon={<IconChevronRight size={20} color='#f20a61' />}
                >
                  <List.Item>
                    <Text fw={500} span>Bonificación de lanzamiento:</Text>
                    <Text>Todas las microcredenciales cuentan con un 25% de descuento utilizando el código promocional UAIADVANCE2025. Este beneficio aplica sobre el precio de lista y se encuentra vigente por tiempo limitado. (Este beneficio no aplica para miembros de la comunidad UAI/VANEDUC).</Text>
                  </List.Item>
                </List>
              </Box>

              <Box>
                <Title order={3} fw={500} mb="md">Para la comunidad UAI/VANEDUC:</Title>
                <Text mb="xs">(Empleados, docentes, estudiantes y graduados)</Text>
                <List 
                  withPadding 
                  spacing="xs" 
                  size='md' 
                  icon={<IconChevronRight size={20} color='#f20a61' />}
                >
                  <List.Item>
                    <Text fw={500} span>Descuento exclusivo:</Text>
                    <Text> Accedé hasta un 50% de descuento sobre el precio de lista en todas las microcredenciales.</Text>
                  </List.Item>
                </List>
              </Box>

              <Divider color='#f20a61' mt={'1rem'} mb={'1rem'} />

              <Box>
                <Title order={3} fw={500} >Formas de pago:</Title>
                <List 
                  withPadding 
                  spacing="xs" 
                  size='md' 
                  icon={<IconChevronRight size={20} color='#f20a61' />}
                >
                  <List.Item>
                    <Text> Podés realizar el pago en hasta 3 cuotas sin interés con las siguientes tarjetas:</Text>
                  </List.Item>
                </List>
                <Center mt={15}>
                  <Group spacing="lg" >
                    <Image 
                      src={logoVisa}
                      width={60} 
                      height={40} 
                      fit="contain"
                    />
                    <Image 
                      src={logoMastercard}
                      width={60} 
                      height={40} 
                      fit="contain"
                    />
                    <Image 
                      src={logoAmericanExpress} 
                      width={60} 
                      height={40} 
                      fit="contain"
                    />
                  </Group>
                </Center>
                <Text size="sm" c="dimmed" ta="center" mt={5}>
                  Visa crédito y débito, Mastercard crédito, American express
                </Text>
              </Box>
            </>
            )
          ) : (
            <>
              {bonifHtml ? (
                /* Contenido vivo desde Umbraco (trae su propio banner e incluye
                   ingreso vigente, vigencia, ingresantes y rematriculados). */
                <TypographyStylesProvider>
                  <div dangerouslySetInnerHTML={{ __html: bonifHtml }} />
                </TypographyStylesProvider>
              ) : bonifHtml === null ? (
                /* Cargando: no mostrar datos viejos que después se pisan. */
                null
              ) : (
                /* Respaldo si Umbraco no respondió o vino vacío. */
                <>
                  <Image
                    src={bonificaciones_img}
                    height={120}
                    fit="cover"
                  />
                  <Box>
                    <Title fw={500}>
                      Ingreso <Text span inherit c='#f20a61'>Agosto 2026</Text><br/>
                      <Text size="0.8rem">
                    Vigencia hasta el<Text span inherit fw={400} c="rgb(208, 25, 89)"> 15/06/2026 </Text>
                  </Text>
                      <Text span fw={500} size='1rem' style={{ textDecoration: "underline" }}>Ingresantes y nuevas carreras (baja o egresado de otra carrera)</Text>
                    </Title>
                    <List
                      withPadding
                      spacing="xs"
                      mt="xs"
                      size='md'
                      icon={<IconChevronRight size={20} color='#f20a61' />}
                    >
                      <List.Item>Hasta el 60 % matrícula bonificada.</List.Item>
                    </List>
                  </Box>

                 <Divider color='#f20a61' mt={'1rem'} mb={'1rem'}></Divider>
                  <Box>
                    <Text size="xl" fw={500} mb={'xs'}  style={{ textDecoration: "underline" }}>Rematriculados</Text>
                    <List
                      withPadding
                      spacing="xs"
                      size='md'
                      icon={<IconChevronRight size={20} color='#f20a61' />}
                    >
                      <List.Item>50% Matricula bonificada.</List.Item>
                      <List.Item>El descuento NO aplica para bajas posteriores al 30/09/2025.</List.Item>
                      <List.Item>Los beneficios NO son acumulables con otras promociones.</List.Item>
                      <List.Item>No aplica beneficio a quien tiene deuda</List.Item>
                    </List>
                  </Box>
                </>
              )}
              <Divider color='#f20a61' mt={'1rem'} mb={'1rem'}></Divider>
              <Box mb={'md'} >
                <Title mb={'lg'} fw={500} > Carreras de Posgrado <Text span inherit c='#f20a61'>Abril 2026</Text></Title>
                <List 
                  withPadding 
                  spacing="xs" 
                  size='md' 
                  icon={<IconChevronRight size={20} color='#f20a61' />}
                >
                  <List.Item>Graduados UAI: 70% de descuento en matrícula de ingreso + beca del 20%</List.Item>
                  <List.Item>Rematriculados: 70% de descuento en matrícula de ingreso</List.Item>
                  <List.Item>Externos: 60% de descuento en matrícula de ingreso</List.Item>
                </List>
              </Box>
              <Box mt={'md'} mb={'md'} >
                <Text size="xl" fw={500} mb={'md'}>Beneficio por inscripción en grupo de posgrados</Text>
                <List 
                  withPadding 
                  spacing="xs" 
                  size='md' 
                  icon={<IconChevronRight size={20} color='#f20a61' />}
                >
                  <List.Item>Grupo de 3 a 5 profesionales - <Text span fw={700} size='0.9rem'>beca del 15%</Text> sobre el arancel mensual</List.Item>
                  <List.Item>Más de 6 profesionales - <Text span fw={700} size='0.9rem'>beca del 20%</Text> sobre el arancel mensual</List.Item>
                </List>
                <Space h="lg"/>
                <Alert variant="outline" color="#f20a61" title="Aclaraciones" icon={(<IconExclamationCircle/>)}>
                  <List 
                    spacing="xs" 
                    size='sm' 
                    icon={<IconPoint size={20} color='#f20a61' />}
                  >
                    <List.Item>El beneficio no es acumulable con otras becas.</List.Item>
                    <List.Item>La beca no cubre derechos de examen, matrícula, tutoría de tesis.</List.Item>
                    <List.Item>Cuando lleguen estos casos. Los mismos serán notificados vía mail a la administración correspondiente con el detalle de: <Text span inherit fs="italic"> Carrera / Nombre / Apellido / Legajo / DNI</Text></List.Item>
                    <List.Item>Para que se acredite la bonificación comercial sobre precio de cuotas en los siguientes posgrados, deberán adherirse al débito automático: MP2 y MP4.</List.Item>

                  </List>
                </Alert>
              </Box>

              <Group justify="center">
                <Button 
                  variant="filled" 
                  color="#f20a61"
                  size="sm"
                  component="a" 
                  fullWidth={isMobile}
                  href="https://uai.edu.ar/formas-de-pago/"
                  target="_blank"
                >
                  Ver formas de pago
                </Button>
              </Group>
              <Anchor 
                ta={'center'}
                fw={600}
                underline="hover"
                href="https://uai.campusargentina.com/estudia_en_argentina"
                target="_blank"
                c="#f20a61"
              >
                Bonificaciones especiales para alumnos no residentes
              </Anchor>
              <Divider mt={'lg'} color='#f20a61' />
              
              <Box mt={'md'}>
                <Stack align="center" spacing="xs">
                  <Image src={imagen2} w={104} h={103} />
                  <Text size="lg" fw={600} mb={'md'} ta="center">
                    Clarín 365 / 365 Plus para suscriptores de Clarín 365 o miembros del grupo familiar (madre, padre, hermanos, hijos)
                  </Text>
                </Stack>
                <List 
                  withPadding 
                  spacing="xs" 
                  size='md' 
                  icon={<IconRosetteDiscount size={20} color='#f20a61' />}
                >
                  <List.Item>
                    <Text fw={500} span size='md'>50% de matrícula para ingresantes </Text>en carreras de Grado y Posgrado
                    <Text fs={'italic'} size='sm' c={'rgb(63, 63, 63)'}> (no acumulativo con otras bonificaciones)</Text> 
                  </List.Item>
                  <List.Item >
                    <Text fw={500} span size='md' >30% de descuento</Text> en todos los Cursos de Extensión (*)
                  </List.Item>
                  <List.Item>
                    <Text fw={500} span size='md'>20% de descuento </Text> en todas las cuotas de Posgrado (**)
                  </List.Item>
                </List>
                <Space h="md" />
                <Text size="xs" mt="xs">
                  (*) El descuento se aplica por un máximo de 6 meses en Cursos de Extensión cuyo arancel mensual sea menor o similar al arancel de la carrera Lic. en Enfermería. Para cursos de mayor valor, se tomará como tope el 20% del valor de la cuota de la Lic. en Enfermería durante 6 meses. No aplica a cuotas vencidas.
                  <br /><br />
                  (**) No aplica a cuotas vencidas, y solo aplica sobre el concepto CUOTA.
                  <Space h="md" />
                </Text>
              </Box>

              <Box>
                <Stack align="center" spacing="xs">
                  <Image src={imagen3} w={182} h={103} />
                  <Text size="lg" fw={600} mb={'md'} ta="center">
                    Club La Nación para suscriptores de Club La Nación o miembros del grupo familiar (madre, padre, hermanos, hijos).
                  </Text>
                </Stack>

                <List 
                  withPadding 
                  spacing="xs" 
                  size='md' 
                  icon={<IconRosetteDiscount size={20} color='#f20a61' />}
                >
                  <List.Item>
                    <Text fw={500} span size='0.95rem'>50% de matrícula para ingresantes </Text>en carreras de Grado y Posgrado
                    <Text fs={'italic'} size='sm' c={'rgb(63, 63, 63)'}>(no acumulativo con otras bonificaciones)</Text>
                  </List.Item>
                  <List.Item>
                    <Text fw={500} span size='0.95rem' >30% de descuento</Text> en todos los Cursos de Extensión (*)
                  </List.Item>
                  <List.Item>
                    <Text fw={500} span size='0.95rem'>20% de descuento </Text> en todas las cuotas de Posgrado (**)
                  </List.Item>
                </List>
                <Space h="md" />
                <Text size="xs" mt="xs">
                  (*) El descuento se aplica por un máximo de 6 meses en Cursos de Extensión cuyo arancel mensual sea menor o similar al arancel de la carrera Lic. en Enfermería. Para cursos de mayor valor, se tomará como tope el 20% del valor de la cuota de la Lic. en Enfermería durante 6 meses. No aplica a cuotas vencidas.
                  <br/><br/>
                  (**) No aplica a cuotas vencidas, y solo aplica sobre el concepto CUOTA.
                </Text>
              </Box>
              <Box mt={'dm'}>
                <Alert variant="outline" color="#f20a61" title="Requisito para validar la compensación" icon={(<IconExclamationCircle/>)}>
                  <Text size='sm'>
                    Validar la tarjeta de descuento al momento de formalizar la inscripción (únicamente), por el titular de la misma presentando DNI y presentar acreditación de vínculo en caso de familiar directo.
                  </Text>
                </Alert>
              </Box>
            </>
          )}
        </Stack>
      </div>
    </Modal>
  );
};

export default BonusesInfoModal;

